import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { storeAccessToken } from "../../../redux/userview/userviewaction";
import { HOME_PAGE } from "../../../Routes/Routes";

const SAML = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const cookies = document.cookie.split("; ");
    const tokenCookie = cookies.find((cookie) => cookie.startsWith("auth_token="));
    const token = tokenCookie ? tokenCookie.split("=")[1] : null;

    if (token) {
      dispatch(storeAccessToken({ access_token: token }));
      // Clear the cookie
      document.cookie = "auth_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }

    navigate(HOME_PAGE);
  }, [dispatch, navigate]);

  return (
    <div className="popup_loading_overlay_box">
      <div className="zino_renderer_loader"></div>
    </div>
  );
};

export default SAML;
